import React from "react";

function IconSearch(props) {
    return (<svg className = {props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.6">
            <circle cx="10" cy="10" r="6" stroke="#144066" stroke-width="2"/>
            <rect x="13.5532" y="14.7971" width="2" height="8" rx="1" transform="rotate(-45 13.5532 14.7971)" fill="#144066"/>
        </g>
    </svg>);
}

export default IconSearch
